import VMasker from 'vanilla-masker';

export const formatAmount = (amount: string | number, options?: any) => {
  if (!amount) return '';
  return VMasker.toMoney(amount, options);
}

// export const numberToMoneyString = (amount: number): string => {
//   const integerPart: string = VMasker.toMoney(Math.trunc(amount), {
//     precision: 0,
//     separator: ',',
//     delimiter: '.',
//     zeroCents: false
//   });

//   const decimalPart: string = (amount - Math.trunc(amount)).toFixed(2).replace('0.', ',');
//   return integerPart + decimalPart;
// }

export const numberToMoneyString = (amount: number): string => {
  const formattedAmount = amount.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });

  return formattedAmount;
}

export const moneyStringToNumber = (money: string): number => {
  return Number(money.replace(/\./g, '').replace(/,/, '.'));
}

export const maskDate = (date: string) =>
  VMasker.toPattern(date, "SS/SS/SSSS");

export const maskZipCode = (zipCode: string) =>
  VMasker.toPattern(zipCode, "SSSSS-SSS");

export const maskPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return '';
  const onlyNumbers = phoneNumber.replace(/\D/g, '');
  if (!onlyNumbers) return '';
  if (onlyNumbers.length <= 10) {
    return VMasker.toPattern(onlyNumbers, "(SS) SSSS-SSSS");
  } else {
    return VMasker.toPattern(onlyNumbers, "(SS) SSSSS-SSSS");
  }
}

export const unmaskPhoneNumber = (value: string) => value.replace(/\(|\)|\+|-|\s*/g, '');

export const fixNumber = (value: number) => {
  return value.toFixed(2).replace('.', ',');
  // if (!(value.toString().indexOf(".") >= 0) && !(value.toString().indexOf(',') >= 0)) {
  //   return Number(
  //     value.toString().slice(0, -2)
  //     + '.' +
  //     value.toString().substring(value.toString().length, value.toString().length - 2)
  //   );
  // }
  // return value;
};

export const fixMissingZerosNumber = (value: number) => {
  if (!(value.toString().indexOf(".") >= 0) && !(value.toString().indexOf(',') >= 0)) {
    return Number(value + '.00');
  }
  return value;
}

export const maskMoney = (value: string, float = false, precision = 2) => {
  const toParse = !float ? value.replace(/\./g, '').replace(/,/, '.') : value;

  return parseFloat(toParse)
    .toFixed(precision)
    .toString()
    .replace(/\./, ',')
    .replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
};

export const unmaskMoney = (value: string) => parseFloat(`${value}`.replace(/\./g, '').replace(/,/, '.'));

export {
  maskCpf,
  maskCnpj,
  maskCpfOrCnpj,
  unmaskCpfOrCnpj,
  normalizeDocument,
} from '../shared/documents';

export const DATE_INPUT_MASK = [/[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
